// ============================================================
// VÍDEO — abre o institucional no Fancybox
// O Fancybox v3 depende de jQuery e só é carregado na home
// (framework/includes/css-js.php). A galeria usa o mesmo Fancybox,
// ligando sozinha pelo [data-fancybox] — opções em 32.gallery.js.
// ============================================================

(function ($) {
    'use strict';

    $(function () {
        var $video = $('[data-fancyboxvideo]');

        if (!$video.length) return;
        if (typeof $.fn.fancybox === 'undefined') return;

        $video.fancybox({
            youtube: {
                showinfo: 0,
                rel: 0
            },
            vimeo: {
                color: 'D82507'
            },
            buttons: ['close'],
            animationEffect: 'fade',
            transitionEffect: 'fade'
        });
    });
})(jQuery);
